import { render, staticRenderFns } from "./MyShopping.vue?vue&type=template&id=71ccb253&scoped=true"
import script from "./MyShopping.vue?vue&type=script&lang=js"
export * from "./MyShopping.vue?vue&type=script&lang=js"
import style0 from "./MyShopping.vue?vue&type=style&index=0&id=71ccb253&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ccb253",
  null
  
)

export default component.exports